<template>
  <hm-content title="">
    <div class="">
      <div class="tip-msg flex flex-wrap">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
            alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble">
            您收到一封来自{{ row.realName }}的总目标“{{
              row.planName
            }}”拆分邀请。<br />
            请您拆分“<span class="blue">{{ row.planTargetName }}</span
            >”的目标！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="flex flex-center item-center" style="height: 400px">
        <el-tooltip
          :disabled="okrPlanBasicInfo.A === 'completed'"
          class="item"
          effect="dark"
          :content="
            okrPlanBasicInfo.A === 'editing'
              ? '拆分商品目标'
              : '请先完成上一步哦!'
          "
          placement="top"
        >
          <div class="ork-module inline-block mr110">
            <div
              class="ork-module-btn-wrapper"
              v-if="okrPlanBasicInfo.A === 'completed'"
            >
              <div class="flex item-center wrapper">
                <div class="flex flex-wrap flex-start">
                  <el-tooltip
                    class="item"
                    content="编辑"
                    placement="top"
                    style="color: #0081e5"
                  >
                    <el-button
                      @click="edit('1', '拆分商品目标')"
                      icon="hmicon icon-bianji"
                      circle
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div
              class="okr-img flex flex-center item-center pointer"
              @click="goAdd('1', '拆分商品目标')"
            >
              <img
                src="https://imgcdn.hemiao100.com/ThemePictures/%E6%8B%86%E5%88%86%E5%95%86%E5%93%81%E7%9B%AE%E6%A0%87%402x.png"
                alt=""
              />
            </div>

            <!-- <div class="flex flex-center ork-title">1.拆分商品目标</div> -->
            <div class="flex flex-center mt10">
              <el-button
                v-if="okrPlanBasicInfo.A === 'completed'"
                type="primary"
                class="okr-btn-success"
                size="small"
              >
                <span class="hmicon icon-duigou"></span>
              </el-button>
              <el-button
                type="primary"
                size="small"
                class="okr-btn-false"
                :disabled="true"
                v-if="okrPlanBasicInfo.A === 'disable'"
                >去制定</el-button
              >
              <el-button
                v-if="okrPlanBasicInfo.A === 'editing'"
                type="primary okr-btn"
                size="small"
                @click="goAdd('1', '拆分商品目标')"
                >去拆分</el-button
              >
            </div>
            <!-- <div class="pointer edit" @click="edit('1', '拆分商品目标')" v-if="okrPlanBasicInfo.A==='completed'">
            <span class="hmicon icon-bianji blue"></span>
          </div> -->
            <div class="line"></div>
          </div>
        </el-tooltip>
        <el-tooltip
          :disabled="okrPlanBasicInfo.B === 'completed'"
          class="item"
          effect="dark"
          :content="
            okrPlanBasicInfo.B === 'editing'
              ? '预览门店目标'
              : '请先完成上一步哦!'
          "
          placement="top"
        >
          <div class="ork-module inline-block mr110">
            <div
              class="okr-img flex flex-center item-center pointer"
              v-if="okrPlanBasicInfo.B === 'editing'"
              @click="goAdd('2', '预览门店目标')"
            >
              <img
                src="https://imgcdn.hemiao100.com/ThemePictures/%E9%A2%84%E8%A7%88%E5%B9%B6%E5%8F%91%E5%B8%832%402x.png"
                alt=""
              />
            </div>
            <div class="okr-img flex flex-center item-center" v-else>
              <img
                src="https://imgcdn.hemiao100.com/ThemePictures/%E9%A2%84%E8%A7%88%E5%B9%B6%E5%8F%91%E5%B8%832%402x.png"
                alt=""
              />
            </div>

            <!-- <div class="flex flex-center ork-title">2.预览门店目标</div> -->
            <div class="flex flex-center mt10">
              <el-button
                type="primary"
                class="okr-btn-success"
                size="small"
                v-if="okrPlanBasicInfo.B === 'completed'"
              >
                <span class="hmicon icon-duigou"></span>
              </el-button>
              <el-button
                v-if="okrPlanBasicInfo.B === 'disable'"
                type="primary"
                size="small"
                class="okr-btn-false"
                :disabled="true"
                >去预览</el-button
              >
              <el-button
                v-if="okrPlanBasicInfo.B === 'editing'"
                type="primary okr-btn"
                size="small"
                @click="goAdd('2', '预览门店目标')"
                >去预览</el-button
              >
            </div>
            <!-- <div class="pointer edit" @click="edit('2', '预览门店目标')">
            <span class="hmicon icon-bianji blue"></span>
          </div> -->
            <!-- <div class="line"></div> -->
          </div>
        </el-tooltip>
        <!-- <div class="ork-module inline-block mr110">
          <div class="okr-img flex flex-center item-center">
            <img
              src="https://imgcdn.hemiao100.com/ThemePictures/fabu.png"
              alt=""
            />
          </div>

          <div class="flex flex-center ork-title">3.确认发布</div>
          <div class="flex flex-center">
            <el-button type="primary" class="okr-btn-success" size="small" v-if="okrPlanBasicInfo.C==='completed'">
              <span class="hmicon icon-duigou"></span>
            </el-button>
            <el-button
              type="primary"
              size="small"
              class="okr-btn-false"
              v-if="okrPlanBasicInfo.C==='disable'"
              :disabled="true"
              >去制定</el-button
            >
            <el-button
              type="primary okr-btn"
              size="small"
              v-if="okrPlanBasicInfo.C==='editing'"
              @click="goAdd('3', '确认发布')"
              >去发布</el-button
            >
          </div>
        </div> -->
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :width="type === '1' ? '800px' : '1200px'"
    >
      <div class="tip-msg flex flex-wrap mb10">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
            alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble" v-if="type === '1'">
            <!-- 请去拆分商品KR吧，根据百分比自动生成商品KR！ -->
            请去拆分商品KR吧
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span class="bubble leftBubble" v-if="type === '2'">
            请预览门店目标！
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div v-if="type === '1'">
        <div class="flex flex-end">
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出模板数据</el-button
          >

          <el-button type="primary" size="small" class="open-file pointer"
            >导入数据
            <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </el-button>
        </div>

        <hm-okr-table
          ref="okrtable"
          :params="row"
          :data="columnList"
          :headersList="headersList"
        >
        </hm-okr-table>
      </div>
      <div v-if="type === '2'">
        <el-table
          :data="columnList"
          style="width: 100%"
          border
          stripe
          size="small"
          :max-height="400"
          row-key="id"
          default-expand-all
          :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            v-for="(col, index) in headersList"
            :key="index"
            :min-width="index === 0 ? '200px' : '130px'"
            :prop="col.columnName"
            :label="col.labelName1"
            header-align="center"
            show-overflow-tooltip
            :align="index != 0 ? 'right' : 'left'"
            :column-key="index.toString()"
          >
            <template slot="header">
              <!-- <div class="flex flex-column flex-between"> -->
              <el-tooltip :content="col.labelName + ''" placement="top-start">
                <div class=" flex flex-center text-overflow">
                  {{ col.labelName }}
                </div>
              </el-tooltip>
              <div
                class=" bm flex flex-center"
                v-if="col.columnName !== 'goodsName'"
              >
                {{ col.labelName2 }}%
              </div>
              <!-- </div> -->
            </template>
            <template slot-scope="scope">
              {{ index != 0 ? "￥" : "" }}
              {{
                index != 0
                  ? toPriceNum(scope.row[col.columnName].toFixed(2))
                  : scope.row[col.columnName]
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="submitRuleForm('ruleForm')"
          size="small"
          type="primary"
          >{{ type === "1" ? "保存" : "发布" }}</el-button
        >

        <el-button @click="close" size="small" type="info">关闭</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmOkrTable from "@/components/HmOkrTable";
import { treeConvertToArr, ToFixed } from "@/utils/utils";
// import HmShopGoodsOkr from "@/components/HmShopGoodsOkr";

import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmOkrTable },
  data() {
    return {
      tableData: [],
      ruleForm: {},
      innerVisible: false,
      dialogVisibleGoods: false,
      type: "",
      title: "",
      dialogVisible: false,
      okrPlanBasicInfo: {},
      row: JSON.parse(this.$route.query.row),
      headersList: [],
      columnList: [],
      isOutputing: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryStoreOkrTaskDetailInfoState();
  },
  methods: {
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let goodsList = [];

        result.forEach(v => {
          goodsList.push({
            id: v[0],
            goodsName: v[1],
            planValue: ToFixed(v[2] || 0, 2)
          });

          // if (v[0] || v[1]) {
          //   goodsSnsAndSpecBarcode.push({
          //     goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
          //     specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
          //   });
          // }
        });
        goodsList.forEach(v => {
          that.mapAry(that.columnList, v);
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    //导出excel
    output() {
      this.isOutputing = true;
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const list = treeConvertToArr(this.columnList);
        const tHeader = ["ID(请勿修改)", "目标商品", "目标值"];
        const filterVal = ["id", "goodsName", "planValue"];
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(
          tHeader,
          data,
          "导出模板" + new Date().toLocaleString()
        );
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    //导入的递归
    mapAry(arr, item) {
      arr.forEach(v => {
        if (v.id == item.id) {
          v.planValue = item.planValue;
        }
        if (v.children && v.children.length) {
          this.mapAry(v.children, item);
        }
      });
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    async queryStoreOkrTaskDetailInfoState() {
      let params = {
        planId: this.row.planId,
        targetId: this.row.targetId
      };
      const { code, result } = await this.$store.dispatch(
        "queryStoreOkrTaskDetailInfoState",
        params
      );
      if (code === "0") {
        this.okrPlanBasicInfo = result;
      }
    },
    close() {
      this.dialogVisible = false;
    },
    async updateOkrTargetSplitState(state) {
      let params = {
        planId: this.row.planId,
        state,
        targetId: this.row.targetId
      };
      const { code } = await this.$store.dispatch(
        "updateOkrTargetSplitState",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        if (state === "publish") {
          this.$router.push({
            name: "SplitOkrWorkDetails",
            query: {
              targetId: this.row.targetId
            }
          });
        } else {
          this.queryStoreOkrTaskDetailInfoState();
        }
        this.dialogVisible = false;
      }
    },
    async submitRuleForm() {
      if (this.type === "1") {
        let params = {
          planId: this.row.planId,
          targetId: this.row.targetId,
          columnList: this.columnList
        };
        let name =
          this.state === "edit"
            ? "editOkrTargetSplitInfo"
            : "saveStoreOkrTaskDetailInfo";
        const { code } = await this.$store.dispatch(name, params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.queryStoreOkrTaskDetailInfoState();
        }
      } else if (this.type === "2") {
        this.updateOkrTargetSplitState("publish");
      } else if (this.type === "3") {
        this.updateOkrTargetSplitState("publish");
      }
    },
    async queryStoreOkrTaskDetailInfo() {
      const { code, result } = await this.$store.dispatch(
        "queryStoreOkrTaskDetailInfo",
        {
          targetId: this.row.targetId
        }
      );
      if (code === "0") {
        const { headersList, columnList } = result;
        console.log("headersList: ", headersList);
        this.headersList = headersList;
        this.columnList = columnList;
      }
    },
    async queryShopTargetSplitInfo() {
      const { code, result } = await this.$store.dispatch(
        "queryShopTargetSplitInfo",
        {
          targetId: this.row.targetId,
          planId: this.row.planId
        }
      );
      if (code === "0") {
        const { headersList, columnList } = result;
        this.headersList = headersList;
        this.columnList = columnList;
      }
    },
    goAdd(type, title) {
      console.log("add")
      this.type = type;
      if (type !== "3") {
        this.headersList = [];
        this.columnList = [];
        this.title = title;
        this.dialogVisible = true;
      }

      this.state = "add";
      if (type === "1") {
        this.queryStoreOkrTaskDetailInfo();
      } else if (type === "2") {
        this.queryShopTargetSplitInfo();
      } else if (type === "3") {
        this.submitRuleForm();
      }
    },
    async queryStoreOkrTaskDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryStoreOkrTaskDetails",
        {
          targetId: this.row.targetId
        }
      );
      if (code === "0") {
        const { headersList, columnList } = result;
        this.headersList = headersList;
        this.columnList = columnList;
      }
    },
    edit(type, title) {
      this.headersList = [];
      this.columnList = [];
      this.type = type;
      this.title = title;
      this.dialogVisible = true;
      this.state = "edit";
      this.queryStoreOkrTaskDetails();
    },
    saveGoods() {}
  }
};
</script>
<style lang="scss" scoped>
.bm {
  border-top: 1px solid #ebeef5;
}
.inline-block {
  display: inline-block;
}
.mr110 {
  margin-right: 120px;
}
.ork-module {
  position: relative;
  width: 220px;
  height: 233px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 0.39);
  padding: 10px;

  .edit {
    position: absolute;
    left: 0;
    top: 0;
    background: #ffffff;
    display: none;
    .icon-bianji {
      font-size: 20px;
    }
  }
  &:hover {
    .ork-module-btn-wrapper {
      display: block;
    }
  }
  &-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 38px;
    height: 170px;
    padding-left: 100px;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    .wrapper {
      height: 100%;
    }
    .el-button {
      margin: 0;
      margin-top: 20px;
      margin-right: 15px;
    }
  }
  .okr-img {
    // height: 120px;
    width: 220px;
    background: #fff1f7;
    img {
      width: 100%;
      // height: 84px;
    }
  }
  .ork-title {
    font-weight: 600;
    color: #222222;
    height: 52px;
    line-height: 52px;
    font-size: 16px;
  }
  .okr-btn {
    margin-top: 10px;
    width: 100%;
    height: 36px;
    border-radius: 4px;
  }
  .okr-btn-false {
    margin-top: 10px;
    width: 100%;
    height: 36px;
    border-radius: 4px;
    background: #dddddd;
    border-color: #dddddd;
  }
  .okr-btn-success {
    margin-top: 10px;
    width: 100%;
    height: 36px;
    border-radius: 4px;
    background: #2fc348;
    border-color: #2fc348;
  }
  .line {
    position: absolute;
    right: -111px;
    bottom: 120px;
    width: 101px;
    height: 6px;
    background: #eeeeee;
  }
  .left-line {
    position: absolute;
    left: -111px;
    bottom: 120px;
    width: 101px;
    height: 6px;
    background: #eeeeee;
  }
}
</style>
